import React from "react";

const WebrcadeContext = React.createContext({});
export { WebrcadeContext }
